export default {
  'meta': {
    'langName': 'PORTUGUÊS',
    'lang': 'Português'
  },
  'title': 'RECOLHA DO PRODUTO: TROTINETE ELÉTRICA SD500E ou MD500E da marca BTWIN',
  'description': 'Caro client(e),\n\nAdquiriu a trotinete elétrica SD 500E ou MD500E da marca BTWIN e agradecemos-lhe por isso. Uma vez que a sua segurança é a nossa prioridade, pedimos-lhe que tome conhecimento das seguintes informações. \n\nNa sequência dos nossos controlos de qualidade, verificámos que estas trotinetes elétricas apresentam um defeito de segurança. A utilização intensiva do equipamento pode originar o aparecimento de uma fissura na junção entre o quadro e o avanço. Este defeito poderá provocar a rutura da referida junção, existindo o risco de queda do utilizador.\r\n\n \n\nSugerimos que responda às seguintes perguntas para que possamos fornecer-lhe a solução adequada para garantir a segurança do seu produto.\n\nPedimos desculpa pelo transtorno causado e agradecemos a sua confiança.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Antes de mais, agradecemos que confirme o seu endereço de email e país de residência:'
  },
  'fields': {
    'country': 'País',
    'address': 'Email',
    'email': 'Email',
    'phonePrefix': 'Indicativo telefónico de País',
    'phone': 'Número de telefone',
    'validations': {
      'phoneOrEmail': 'Por favor, indique pelo menos um endereço de email ou um número de telefone.',
      'email': 'Por favor, introduza um endereço de email válido',
      'phone': 'Por favor, introduza um número de telefone válido',
      'selectAddress': 'Por favor, escolha um endereço completo da lista (número, rua e cidade).',
      'incompleteAddress': 'O endereço deve incluir um número, uma rua e uma cidade. Introduza, pelo menos, o número e o nome da rua e, em seguida, selecione uma das sugestões.'
    },
    'firstName': 'Apelido',
    'lastName': 'Nome',
    'deliveryAddress': 'Morada para envio da encomenda',
    'additionalAddress': 'Informações adicionais da morada',
    'city': 'Localidade',
    'zip': 'Código Postal',
    'readConfirmation': 'Verifiquei os meus dados pessoais, tomei conhecimento das informações e comprometo-me a respeitá-las.\r\n\r',
    'choose': 'Selecionar',
    'required': 'Campo obrigatório',
    'deliveryAddressHelp': 'Introduza o número e o nome da rua e, em seguida, selecione um endereço completo da lista.',
    'streetOnlyHint': 'Adicione um número'
  },
  'ownerCheck': {
    'title': 'Ainda possui uma ou mais trotinetes elétricas SD500E e MD500E da marca BTWIN?'
  },
  'yes': 'SIM',
  'no': 'NÂO',
  'ownerChanged': {
    'title': 'Dispõe dos dados de contacto do atual proprietário?',
    'confirmation': 'Exmo.(a) Senhor(a),\n\nAgradecemos a sua participação nesta iniciativa de qualidade.\n\nPedimos desculpa pelo incómodo causado e agradecemos a sua confiança.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Indique-nos a quantidade de trotinetes elétricas SD500E e MD500E da marca BTWIN',
    'descriptionSd500': 'trotinetes elétricas  SD500E',
    'descriptionEmd500e': 'trotinetes elétricas  MD500E',
    'modelNumberHelp': 'Encontrará a referência do modelo (SD500E ou MD500E) na parte inferior da sua trotinete, tal como ilustrado aqui:',
    'quantity': 'Quantidade',
    'confirmation': 'Obrigado por preencher este formulário. O seu pedido foi devidamente registado. \n\nEntraremos em contacto consigo, no prazo máximo de 20 dias, para lhe comunicar a data a partir da qual poderá efetuar a reparação.\n\nDesejamos-lhe um bom dia\n\nDECATHLON'
  },
  'repair': {
    'title': 'Reparação realizada por si',
    'description': 'Pedimos que deixe de utilizar imediatamente a trotinete objeto desta recolha.\n\nSer-lhe-á enviado gratuitamente para o seu domicílio um kit de reparação, acompanhado das respetivas instruções, para que possa proceder à fixação da sua trotinete de forma simples e rápida.\n\nApós a introdução dos seus dados, entraremos em contato consigo no prazo máximo de 20 dias para definir a data a partir da qual a reparação estará disponível. \n Faremos todos os esforços para reduzir esses prazos e garantir a sua satisfação.',
    'kitLabel': 'Kit completo de reparação',
    'docLabel': 'Instruções de reparação',
    'callToAction': 'Clique aqui para receber o kit de reparação gratuitamente',
    'infoConfirmation': 'Por favor, verifique os seus dados',
    'validateConfirmation': 'Confirmar',
    'backConfirmation': 'Voltar'
  },
  'repairRequest': {
    'title': 'Por favor, introduza as seguintes informações para receber o seu kit de reparação:'
  },
  'form': {
    'submit': 'Seguinte'
  },
  'status': 'Translation validated by COUNTRY'
} as const
